import DemoSetup from './DemoSetup'
import { Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/authStore'
import { api } from '@/lib/api'
import ClinicOperationsPage from './ClinicOperationsPage'
import { canAccessClinicDemo, pearDemoOrganizationId } from './demoAccess'

export default function DemoRoute() {
 const user = useAuthStore(s => s.user)
 const loading = useAuthStore(s => s.isLoading)
 const allowed=canAccessClinicDemo(user)
 const members=useQuery({queryKey:['clinic-demo-members',pearDemoOrganizationId,user?.id],queryFn:()=>api.getOrganization(pearDemoOrganizationId),enabled:allowed&&!!pearDemoOrganizationId})
 if (loading) return null
 if (!allowed) return <Navigate to="/dashboard" replace />
 return <><DemoSetup/><ClinicOperationsPage demo organizationId={pearDemoOrganizationId || undefined} assignmentScope={`${pearDemoOrganizationId || 'unconfigured'}:${user?.id}`} membersLoading={members.isFetching} membersError={members.isError} demoMembers={(members.data?.users||[]).filter(member=>member.user.is_active).map(member=>({id:member.user.id,label:member.user.name||member.user.email,email:member.user.email}))}/></>
}
